import React, { useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { renderLatexToHtml } from "../services/latexRenderer";
import { Trash2 } from "lucide-react";

/**
 * NodeView فرمول LaTeX آزاد — نمایش زنده KaTeX داخل ادیتور.
 * ویرایش درون‌خطی: با دابل‌کلیک، کادر لاتین همان‌جا روی فرمول باز می‌شود (بدون مودال).
 */
const MathNodeView = ({ node, updateAttributes, deleteNode, selected }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(node.attrs.latex);
  const html = renderLatexToHtml(node.attrs.latex);

  const commit = () => {
    updateAttributes({ latex: draft });
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <NodeViewWrapper
        as="span"
        className="relative inline-block align-middle"
        style={{ direction: "ltr", unicodeBidi: "isolate" }}
      >
        <span
          className="inline-flex items-center gap-1 bg-white border-2 border-blue-400 rounded-lg shadow-md px-1.5 py-1"
          contentEditable={false}
        >
          <input
            autoFocus
            type="text"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") commit();
              if (e.key === "Escape") setIsEditing(false);
            }}
            onBlur={commit}
            placeholder="\\frac{3}{4}"
            className="w-40 outline-none text-sm bg-transparent"
            style={{ fontFamily: "monospace" }}
          />
          {/* پیش‌نمایش کوچک کنار کادر */}
          <span
            className="px-1 border-r border-slate-200"
            dangerouslySetInnerHTML={{ __html: renderLatexToHtml(draft) }}
          />
        </span>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper
      as="span"
      onDoubleClick={() => {
        setDraft(node.attrs.latex);
        setIsEditing(true);
      }}
      className={`relative inline-flex items-center align-middle mx-1 transition-all rounded ${
        selected ? "bg-blue-50/40 ring-2 ring-blue-400" : ""
      }`}
      style={{ direction: "ltr", unicodeBidi: "isolate" }}
    >
      <span
        className="math-live-preview px-1 py-0.5 cursor-pointer"
        style={{ fontSize: "0.88em" }}
        title="دابل‌کلیک برای ویرایش"
        dangerouslySetInnerHTML={{ __html: html }}
      />

      {/* دکمه حذف هنگام انتخاب */}
      {selected && (
        <span className="absolute -top-3 -left-3 flex items-center z-10">
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={deleteNode}
            className="p-1 bg-red-100 text-red-600 hover:bg-red-200 rounded-full shadow-md"
            title="حذف فرمول"
          >
            <Trash2 size={12} />
          </button>
        </span>
      )}
    </NodeViewWrapper>
  );
};

export default MathNodeView;
